export class EstadoUsuarioI {
  idEstadoUsuario : String;
  nombreEstado : String;
  desEstado : String;
}
